import api from "../../../api";
import { getCurrentUserRole, THIRD_PARTY_MEDREPS } from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";

export function salesTarget(sd, ed) {
  return api.get(`sales-target?startDate=${sd}&endDate=${ed}`);
}

export function getLead(query) {

  const apiEndpoint = `leads?${query}`;
  return api.get(apiEndpoint);
}

export function getNewLead(query) {
  const apiEndpoint = `cases?filterAssigned=true&${query}`;
  return api.get(apiEndpoint);
}

export function getCases(query) {
  const apiEndpoint = `cases?${query}`;
  return api.get(apiEndpoint);
}

export function getReps(rep) {
  const apiEndpoint = `role_users?role=${rep}`;
  return api.get(apiEndpoint);
}
export function setSalesTarget(id, payload) {
  return api.post(`sales-target/${id}`, payload);
}

export function slotBooking(query) {
  return api.get(`all_bookings?${query}&isRescheduled=false&isUserBooked=true`);
}

export function requestReport(payload) {
  return api.post("request-report", payload);
}

export const getNearestSlot= () =>{
  return api.get('v4/slots/nearest-medical-slot')
}

export const warehouseDownloadPincode=(email)=>{
  return api.get(`download-warehouse-pincode-mapping-report?email=${email}`);
}

export const caseTagWise =(tagName,page) =>{
  return api.get(`cases-tagwise?pageNumber=${page}&tagName=${tagName}`);
}

export const caseTagDownload = (tag) =>{
  return api.get(`download-tagwise-users?tagName=${tag}`)
}